import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { StoreModule } from '@ngrx/store';
import { featureKey } from './state/core.state';
import { coreReducer } from './state/core.reducers';
import { CoreEffects } from './state/core.effects';
import { EffectsModule } from '@ngrx/effects';
import { TooltipPipe } from './tooltip/tooltip.pipe';

@NgModule({
    declarations: [TooltipPipe],
    imports: [StoreModule.forFeature(featureKey, coreReducer), EffectsModule.forFeature([CoreEffects])],
    exports: [TranslateModule, TooltipPipe],
    providers: []
})
export class CoreModule {}
